/* eslint-disable camelcase */

import { setDangerRowIfEvaluationOverdue } from '@/helpers/evaluation/rapid-access/rapidAccessEvaluations';

function setExperimentColorAndCommentsInProposal(proposal) {
  const { experiment_color = {}, ...otherKeys } = proposal;
  return {
    ...otherKeys,
    experiment_color: {
      evaluated_color: experiment_color.evaluated_color || '',
      safety_evaluation: {
        comments_review: experiment_color.safety_evaluation?.comments_review || '',
        color: experiment_color.safety_evaluation?.color || '',
      },
      radiation_evaluation: {
        comments_review: experiment_color.radiation_evaluation?.comments_review || '',
        color: experiment_color.radiation_evaluation?.color || '',
      },
    },
  };
}

function setExperimentColorAndCommentsInProposals(proposals) {
  return proposals.map((proposal) => setExperimentColorAndCommentsInProposal(proposal));
}

const evaluationsFields = {
  final_grade: ['comments', 'acceptance_mark'],
  management_evaluation: ['number_of_shifts', 'comments', 'acceptance_mark'],
};

function setEvaluationsDataInProposals(proposals, evaluationKey) {
  const fields = evaluationsFields[evaluationKey];
  return proposals.map((proposal) => {
    const evaluation = proposal[evaluationKey] ?? {};
    const isSubmitted = evaluation.states?.name === 'submitted';
    const updatedEvaluation = { ...evaluation };
    fields.forEach((field) => {
      updatedEvaluation[field] = isSubmitted ? evaluation[field] : '';
    });
    return {
      ...proposal,
      [evaluationKey]: updatedEvaluation,
    };
  });
}

function setDataInProposals(proposals) {
  let proposalsUpdated = setEvaluationsDataInProposals(proposals, 'final_grade');
  proposalsUpdated = setEvaluationsDataInProposals(proposalsUpdated, 'management_evaluation');
  return proposalsUpdated.map((proposal) => {
    const { technical_evaluation = {} } = proposal;
    return {
      ...proposal,
      _rowVariant: setDangerRowIfEvaluationOverdue(proposal, technical_evaluation),
    };
  });
}

export {
  setExperimentColorAndCommentsInProposals,
  setExperimentColorAndCommentsInProposal,
  setDataInProposals,
};
